import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-examples',
  templateUrl: './examples.component.html',
  styleUrls: ['./examples.component.scss']
})
export class ExamplesComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
    ) { }

  ngOnInit() {
    this.titleService.setTitle('고급 글쓰기 향상 예시 | Trinka');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka는 독자층이 읽기에 적합한 글이 되도록 돕습니다. 문법적인 오류를 없애는 것은 물론, 어조, 스타일, 가독성, 객관성 등의 요소들을 검사해 고품질 글로 거듭나도록 합니다.' });
    this.metaTagService.updateTag({ name: 'keywords', content: '고급 문법 검사, 학술적 글쓰기 문법 검사기, 기술적 글쓰기 검사, 학술적 글쓰기 지원, 기술적 글쓰기 지원' });
    this.metaTagService.updateTag({ property: 'og:title', content: '고급 글쓰기 향상 예시 | Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka는 독자층이 읽기에 적합한 글이 되도록 돕습니다. 문법적인 오류를 없애는 것은 물론, 어조, 스타일, 가독성, 객관성 등의 요소들을 검사해 고품질 글로 거듭나도록 합니다.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/examples' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/examples' });
    if (isPlatformBrowser(this.platformId)){
    $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
